import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	featureTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-title',
		defaultMessage: 'Products and entitlements',
		description: 'Title text of the products and entitlements feature panel',
	},
	featureDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-description',
		defaultMessage:
			"View and manage the details of your customers' entitlements to your products to get more context when supporting customers. {learnMoreLink}",
		description:
			'Description that explains the affects of products and entitlements. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	featureLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-learn-more',
		defaultMessage: 'Read more about products and entitlements.',
		description: 'Text used in products and entitlements learn more link',
	},
	featureContactAdmin: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-contact-admin',
		defaultMessage: 'Contact your Jira admin to enable or disable this feature.',
		description: 'Prompt in products and entitlements to contact Jira admin to enable',
	},
	featurePrerequisite: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-prerequisite',
		defaultMessage:
			'To use this feature, turn on <strong>Customer and organization profiles</strong>',
		description: 'Prompt in products and entitlement to first enable customer service manegement',
	},
	featureContactSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-contact-success-title',
		defaultMessage: `Products and entitlements {value, select,
            false {turned off}
            true {enabled}
            other {}
        }`,
		description: 'Title text of success flag',
	},
	featureSuccessEnableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-enable-description',
		defaultMessage: 'Start adding products and setting up entitlements on the Products page.',
		description: 'Body text of success flag when products and entitlements feature is enabled',
	},
	featureSuccessDisableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-disable-description',
		defaultMessage: 'You can enable this feature again at any time.',
		description: 'Body text of success flag when products and entitlements feature is disabled',
	},
	featureSuccessEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-enable-action',
		defaultMessage: 'Go to Products page',
		description:
			'Label used in action button in success flag when products and entitlements feature is enabled',
	},
	featureSuccessDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.products-and-entitlements-tile.feature-success-disable-dismiss',
		defaultMessage: 'OK',
		description:
			'Label used in dismiss button in success flag when products and entitlements feature is disabled',
	},
});
